import React from 'react';

interface AppInsightsProviderProps {
  readonly children: React.ReactNode;
}

/**
 * Passthrough today — Application Insights is already initialized at module scope in
 * `appInsights.ts`. Reserved for a future `<AppInsightsContext.Provider>` wrapping.
 */
export function AppInsightsProvider({ children }: AppInsightsProviderProps) {
  return <>{children}</>;
}
